import styled from "styled-components";
import { color, ColorProps } from "styled-system";
import shouldForwardProp from "@pagepro-monorepo/ui/lib/utils/shouldForwardProp";

export const Wrapper = styled("div").withConfig({
  shouldForwardProp
})<ColorProps>`
  ${color};
`;
